import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="submit-action"
export default class extends Controller {
  static targets = ["form", "successAction"];
  static values = { action: String };

  // Handle button click to set success action and submit form
  submit(event) {
    if (!this.formTarget) {
      throw new Error("Form element could not be found"); 
    }
    const successAction = event.currentTarget.getAttribute('data-crud--submit-action-submit-action-value');
    if (!successAction) {
      throw new Error("No success action specified"); 
    }
    
    this.setSuccessAction(successAction);
    this.formTarget.requestSubmit();
  }

  // Set the success action in the hidden input
  setSuccessAction(action) {
    let successActionInput = null;
    if (this.hasSuccessActionTarget) {
      successActionInput = this.successActionTarget;
    } else {
      // Create hidden input if it doesn't exist
      successActionInput = document.createElement("input");
      successActionInput.type = "hidden";
      successActionInput.name = "success_action";
      successActionInput.setAttribute("data-submit-action-target", "successAction");
      this.formTarget.appendChild(successActionInput);
    }
    
    successActionInput.value = action;
  }
}
